export default __webpack_public_path__ + "static/media/mission.43c1e2fe.png";